const Polyglot = require('polyglot');
const locale = require('locale').getDefinitions(); // update this to set your default displaying language in editor

// let polyglot = null;
const polyglot = new Polyglot({phrases: locale.en });
const banknote = require('banknote');
const currencyFormatter = CC_EDITOR ? null : window.PSGames && window.PSGames.CommonAPI
&& window.PSGames.CommonAPI.Currency ? window.PSGames.CommonAPI.Currency : null;

let formattingOptions, formattingOptionsSmall;

module.exports = {
    /**
     * This method allow you to switch language during runtime, language argument should be the same as your data file name
     * such as when language is 'zh', it will load your 'zh.js' data source.
     * @method init
     * @param language - the language specific data file name, such as 'zh' to load 'zh.js'
     */
    init(language, currency) {
        let data;
        if (window.PSGames && window.PSGames.CommonAPI && window.PSGames.CommonAPI.Translations) {
            const Translations = window.PSGames.CommonAPI.Translations;
            data = Translations.getTranslations(language);
        }
        if(!data || Object.keys(data).length === 0){
            data = locale[language];
        }

        if (currencyFormatter) {
            currencyFormatter.init();
        } else {
            formattingOptions = banknote.formattingForLocale(language, currency);
            formattingOptionsSmall = banknote.formattingForLocale(language, currency);
            formattingOptionsSmall.currencySymbol = '';
        }

        polyglot.replace(data);
    },
    /**
     * this method takes a text key as input, and return the localized string
     * Please read https://github.com/airbnb/polyglot.js for details
     * @method t
     * @return {String} localized string
     * @example
     *
     * var myText = i18n.t('MY_TEXT_KEY');
     *
     * // if your data source is defined as
     * // {"hello_name": "Hello, %{name}"}
     * // you can use the following to interpolate the text
     * var greetingText = i18n.t('hello_name', {name: 'nantas'}); // Hello, nantas
     */
    t(key, opt) {
        return polyglot.t(key, opt);
    },

    /**
     *
     * @param {*} key
     * @param {*} opt
     */
    tR(key, replacment) {
        const t = polyglot.t(key);

        Object.keys(replacment).forEach(key => {

        })
    },

    formatCurrency(amount) {
        return currencyFormatter ? currencyFormatter.format(amount) :
            banknote.formatSubunitAmount(amount, formattingOptions);
    },
    formatCurrencySmall(amount) {
        return currencyFormatter ? currencyFormatter.formatSmall(amount) :
            banknote.formatSubunitAmount(amount, formattingOptionsSmall);
    }
};
